// extracted by mini-css-extract-plugin
export default {"sizeFix":"_wz7bfj","collectionDescription":"_ax5e2x"};